import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navigation from './components/Navigation';
import Breadcrumb from './components/Breadcrumb';
import HomePage from './components/pages/HomePage';
import ReleasesPage from './components/pages/ReleasesPage';
import VideosPage from './components/pages/VideosPage';
import AboutSongsPage from './components/pages/AboutSongsPage';
import AboutMePage from './components/pages/AboutMePage';
import MediaPage from './components/pages/MediaPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Navigation />
          <Breadcrumb />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/releases" element={<ReleasesPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/about-songs" element={<AboutSongsPage />} />
            <Route path="/about-me" element={<AboutMePage />} />
            <Route path="/media" element={<MediaPage />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;